<template>
  <mu-row id="dashboardCards" gutter class="content" v-if="$store.state.user.scope">
    <mu-col v-for="chunk, chunkIndex in chunkedOrder" :key="'card-chunk-group-' + chunkIndex" width="100"
            :desktop="desktopWidth"
            tablet="50">


      <div v-for="item, chunkedIndex in chunk" :key="'card-order-' + chunkedIndex">
        <div v-if="item.name === 'ACTIVITY'">
          <activity-input :bmr="$store.state.user.stats.bmr" class="card-spacing bottom"></activity-input>
        </div>

        <div v-if="item.name === 'BLOOD_GLUCOSE'">
          <blood-glucose-input
            class="card-spacing bottom"
            :blood-glucose="$store.state.user.settings.blood_glucose"
            :hba1c="$store.state.user.settings.hba1c"
          />
        </div>
        <div v-if="item.name === 'CHOLESTEROL'">
          <cholesterol-input
            class="card-spacing bottom"
            :blood_glucose="$store.state.user.settings.blood_glucose"
          ></cholesterol-input>
        </div>
        <div v-if="item.name === 'WEIGHT'">
          <weight-input
            class="card-spacing bottom"
            :height="$store.state.user.settings.height"
            :waist="$store.state.user.settings.waist"
            :weight="$store.state.user.settings.weight"
          />
        </div>
        <div v-if="item.name === 'KETONES'">
          <ketones-input
            class="card-spacing bottom"
            :blood-glucose="$store.state.user.settings.blood_glucose"
          />
        </div>
        <div v-if="item.name === 'BLOOD_PRESSURE'">
          <blood-pressure-input
            class="card-spacing bottom"
          />
        </div>
        <div v-if="item.name === 'SLEEP'">
          <sleep-input
            class="card-spacing bottom"
          />
        </div>
        <div v-if="item.name === 'MOOD'">
          <mood-input
            v-if="$store.state.moodList"
            class="card-spacing bottom"
          ></mood-input>
        </div>
        <div v-if="item.name === 'MEDICATION'">
          <medication-input
            class="card-spacing bottom"
          ></medication-input>
        </div>
        <div v-if="item.name === 'INSULIN'">
          <insulin-input
            class="card-spacing bottom"
          ></insulin-input>
        </div>
        <div v-if="item.name === 'NUTRITION'">
          <nutrition-input
            class="card-spacing bottom"
          ></nutrition-input>
        </div>
      </div>
    </mu-col>
  </mu-row>
</template>
<script>
  import CardOrderMixin from '../../../mixins/CardOrderMixin'

  export default {
    name: 'Cards',
    mixins: [
      CardOrderMixin
    ],
    data() {
      return {

      }
    },
    methods: {

    },
    mounted() {
    }
  }
</script>
<style lang="less">
  #dashboardCards {
    .mu-card {
      .mu-card-actions {
        .mu-flexbox {
          white-space: nowrap;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Cards.vue?d4cde378